// ** Custom Components

// ** Third Party Components
import { Menu } from 'react-feather';

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap';
import NavbarUser from './NavbarUser';

type Props = {
  setMenuVisibility: React.Dispatch<React.SetStateAction<boolean>>;
};

const ThemeNavbar = (props: Props) => {
  // ** Props
  // const { skin, setSkin, setMenuVisibility } = props;
  const { setMenuVisibility } = props;

  return (
    <>
      <ul className="navbar-nav d-sm-none">
        <NavItem className="mobile-menu me-auto d-flex align-items-center">
          <NavLink
            className="nav-menu-main menu-toggle hidden-xs is-active"
            onClick={() => setMenuVisibility(true)}
          >
            <Menu className="ficon" />
          </NavLink>
        </NavItem>
      </ul>
      <NavbarUser />
    </>
  );
};

export default ThemeNavbar;
